export enum SUPPORT_PROJECTS_STATUS {
  ON_LIVE = 'ON_LIVE',
  UNRELEASED = 'UNRELEASED',
  DELETED = 'DELETED',
}

export enum SUPPORT_PROJECTS_ACTIONS {
  CREATE = 'CREATE',
  UPDATE = 'UPDATE',
  DELETE = 'DELETE',
  RESTORE = 'RESTORE',
}

export enum SUPPORT_CREDENTIAL_REFERENCE_SECTION {
  PROJECTS = 'Projects',
}

export enum SUPPORT_CREDENTIAL_REFERENCE_CATEGORIES {
  ENVIRONMENT = 'Environment',
}

export enum SUPPORT_CREDENTIAL_REFERENCE_CATEGORY_FIELD {
  NAME = 'Environment',
}
